import { useDispatch, useSelector } from 'react-redux'
import { useCallback, useMemo } from 'react'
import { useFormik } from 'formik'

import EditForm from '../../../../../../features/components/Forms/EditForm'

import ThirdPartyVerificationFieldsSections from '../../../../reusableFormFields/ThirdPartyVerificationFieldsSections'

import { useEditSectionFormSubmit } from '../../../../../../hooks/formHooks/useEditSectionFormSubmit'
import { usePurifiedFormik } from '../../../../../../hooks/formHooks/usePurifiedFormik'
import { formatThirdPartyVerifierToBE } from '../../../../UploadDV360AdCreative/UploadDV360AdCreativeForm/LineItemForm/formatters'

import {
  dv360BulkTargetingWasUpdatedSelector,
  dv360TargetingSelector,
  updateDv360BulkTargetingErrorSelector,
  updateDv360BulkTargetingIsLoadingSelector
} from '../../../../../../modules/selectors/dv360Constants'
import { selectedDV360AdAccountSelector } from '../../../../../../modules/selectors/adAccounts'

import {
  clearUpdateDv360BulkTargeting,
  updateDv360BulkTargeting
} from '../../../../../../modules/actions/dv360Constants'

import { HISTORY_META_EDIT_SECTION, TYPE_LINE_ITEM } from '../../../../../../constants/changeHistory'
import { getInitialValues } from './fields'

function ThirdPartyVerificationSectionForm({ editItemData: item, title, ...formProps }) {
  const dispatch = useDispatch()

  const targeting = useSelector(dv360TargetingSelector)
  const dv360BulkTargetingWasUpdated = useSelector(dv360BulkTargetingWasUpdatedSelector)
  const { id: selectedAdAccountId } = useSelector(selectedDV360AdAccountSelector)

  const initialValues = useMemo(() => {
    return getInitialValues(targeting)
  }, [targeting])

  const handleSubmit = useCallback(
    values => {
      const thirdPartyVerifierTargeting = formatThirdPartyVerifierToBE(values)

      const updateData = {
        account: selectedAdAccountId,
        line_item_id: item.id,
        requests: thirdPartyVerifierTargeting,
        meta: {
          [HISTORY_META_EDIT_SECTION]: title,
          override: {
            item_id: item.id,
            item_type: TYPE_LINE_ITEM,
            action: 'update'
          }
        }
      }

      dispatch(updateDv360BulkTargeting(updateData, true))
    },
    [dispatch, item.id, selectedAdAccountId, title]
  )

  const { onSubmit, manualSuccessSubmit } = useEditSectionFormSubmit({ initialValues, handleSubmit })

  const formik = useFormik({
    initialValues,
    onSubmit,
    enableReinitialize: true
  })
  const purifiedFormik = usePurifiedFormik(formik)

  const handleClearUpdateItem = useCallback(() => {
    dispatch(clearUpdateDv360BulkTargeting())
  }, [dispatch])

  return (
    <EditForm
      formik={purifiedFormik}
      initialValues={initialValues}
      successSubmit={manualSuccessSubmit || dv360BulkTargetingWasUpdated}
      clearEditItem={handleClearUpdateItem}
      errorSelector={updateDv360BulkTargetingErrorSelector}
      isLoadingSelector={updateDv360BulkTargetingIsLoadingSelector}
      {...formProps}
    >
      <br />
      <ThirdPartyVerificationFieldsSections formik={formik} />
    </EditForm>
  )
}

export default ThirdPartyVerificationSectionForm
